import { InstanceService } from "./../../instance/models/instance.service";
import { ModalDirective } from "ng2-bootstrap/components/modal";
import { AuthService } from "./../../shared/models/auth.service";
import { TranslateService } from "./../../shared/translate/translate.service";
import { Component, OnInit, ViewChild } from "@angular/core";
import { NgForm } from "@angular/forms";
import { PersonModel, PersonDeleteModel, PersonRemoveModel } from "../models/person.model";
import { PersonService } from "../models/person.service";
import { Observable } from "rxjs/Observable";
import { Router } from "@angular/router";

import {
  WeGoConfig,
  IAPIResponse,
  ApplicationRouteURL,
  DataListModel,
  WeGoAuthorizedLink,
  Permission,
  UserRoles,
  IKeyValueInterface,
  PermissionType,
  RoleLevel
} from "../../shared/config";
import { FlatPickrDirective } from "../../plugins/flatpickr/flatpickr.directive";
import { FlatPickrModel } from "../../plugins/flatpickr/flatpickr.model";

const moment = require("moment");

@Component({
  selector: "wego-person",
  template: require('../views/person-list.component.html'),
  providers: [PersonService, InstanceService]
})
export class PersonListComponent implements OnInit {
  [name: string]: any;
  DataListModel: DataListModel;
  personList: PersonModel[];
  apiErrorMsg: string;
  isLoading: boolean;
  deletePersonHashId: string;
  message: string;
  validationMessage: string;
  isPermenantDelete: boolean;
  isDelete = false;
  urlPersonUpdate: string;
  urlDefaultPage: string;
  urlImportPerson: string;
  isAllowToImport: boolean = false;
  deleteMessage: string;
  wegoadminUser: string;
  urlBatchUpload: string;
  isAllowToBatchUploadPerson: boolean = false;
  urlPersonAdd: string;
  addPersonLink: WeGoAuthorizedLink;
  importPersonLink: WeGoAuthorizedLink;
  batchUploadPersonLink: WeGoAuthorizedLink;
  errorModel: IKeyValueInterface[];
  model: PersonDeleteModel;
  removalDateTime: Date;
  removalDatePersonHashId: string;
  errorMsg: string;
  flatPickrConfigFrom: FlatPickrModel;

  private popupMsg: string;
  private popupTitle: string;
  private module: string;
  private breadCrumbList: string;
  public dateFormat: string = WeGoConfig.FLATPICKR_DATE_FORMAT;
  roleLevel = RoleLevel;

  @ViewChild("alertModal") public alertModal: ModalDirective;
  @ViewChild("confirmModal") public confirmModal: any;
  @ViewChild("successPopup") public successPopup: any;
  @ViewChild('deletePersonModal') public deletePersonModal: any;
  @ViewChild('personRemovalDateModal') public personRemovalDateModal: any;


  @ViewChild("flatPickrConfigRemovalDate")
  public flatPickrConfigRemovalDate: FlatPickrDirective;


  constructor(
    private personService: PersonService,
    private instanceService: InstanceService,
    private authService: AuthService,
    private router: Router,
    private translate: TranslateService
  ) { }

  ngOnInit() {
    this.wegoadminUser = WeGoConfig.WEGOADMIN_USER;
    this.module = this.translate.instant("LblPerson");
    this.model = new PersonDeleteModel();
    this.DataListModel = this.authService.RetriveFilter(this.constructor.name);
    this.flatPickrConfigFrom = this.SetDefaultFlatPickrConfig(true);

    if (this.authService.GetHighestRoleLevel() <= this.roleLevel.Instance) {
      this.DataListModel.searchField = [
        "userName",
        "firstName",
        "instanceName",
        "lastName",
        "telephone1"
      ];
    } else {
      this.DataListModel.searchField = [
        "userName",
        "firstName",
        "lastName",
        "telephone1"
      ];
    }

    this.urlDefaultPage = this.authService.GetURL(
      ApplicationRouteURL.URL_DEFAULT_PAGE
    );
    this.urlPersonAdd = this.authService.GetURL(
      ApplicationRouteURL.URL_PERSON_ADD
    );
    this.urlPersonUpdate = this.authService.GetURL(
      ApplicationRouteURL.URL_PERSON_UPDATE
    );
    this.urlImportPerson = this.authService.GetURL(
      ApplicationRouteURL.URL_IMPORT_PERSON
    );
    this.urlBatchUpload = this.authService.GetURL(
      ApplicationRouteURL.URL_BATCHUPLOADPERSON
    );
    this.CheckIsAllowToImport();
    this.GetPersonList();
    this.breadCrumbList = this.translate.instant("LblListPage", [this.module]);

    this.addPersonLink = new WeGoAuthorizedLink(
      this.urlPersonAdd,
      Permission.PR_PERSON_OVERVIEW,
      PermissionType.INSERT,
      "btn btn-highlight navbar-right",
      "LblAddNew"
    );

    this.importPersonLink = new WeGoAuthorizedLink(
      this.urlImportPerson,
      Permission.PR_IMPORT_PERSON,
      PermissionType.INSERT,
      "btn btn-highlight pull-right mar_right_10",
      "LblImportPerson"
    );

    this.batchUploadPersonLink = new WeGoAuthorizedLink(
      this.urlBatchUpload,
      Permission.PR_BATCH_UPLOAD_PERSON,
      PermissionType.INSERT,
      "btn btn-highlight pull-right mar_right_10",
      "LblBatchUpload"
    );
  }

  private SetDefaultFlatPickrConfig(isDateOnly?: boolean) {
    let flatPickrConfig = new FlatPickrModel();
    flatPickrConfig.enableTime = !isDateOnly ? true : false;
    flatPickrConfig.time_24hr = true;
    flatPickrConfig.dateFormat = this.dateFormat;
    flatPickrConfig.minuteIncrement = 1;
    flatPickrConfig.minDate = (new Date()).setDate((new Date()).getDate() + 1);
    flatPickrConfig.maxDate = (new Date()).setFullYear((new Date()).getFullYear() + 1);
    return flatPickrConfig;
  }

  get isDeleteAccess(): boolean {
    if (this.personList) {
      return this.personList.some(x => x.isDeletable);
    } else {
      return false;
    }
  }

  get isEditAccess(): boolean {
    if (this.personList) {
      return this.personList.some(x => x.isEditable);
    } else {
      return false;
    }
  }

  public CheckIsAllowToImport() {
    this.instanceService.CheckIsAllowToImportPerson().subscribe(
      res => {
        this.isAllowToImport = res.data;
        //this.isLoading = false;
      },
      error => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        //this.isLoading = false;
      }
    );
    this.instanceService.CheckIsAllowToBatchUploadPerson().subscribe(
      res => {
        this.isAllowToBatchUploadPerson = res.data;
      },
      error => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
      }
    );
  }

  public GetPersonList() {
    this.isLoading = true;
    this.personService.GetPersonList(this.DataListModel).subscribe(
      res => {
        this.personList = res.data;
        this.DataListModel.totalItems = res.totalRecords;
        this.DataListModel.infoMessage = res.error;
        this.isLoading = false;
      },
      error => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      }
    );
  }

  public ShowChangeRemovalDatePopup(person: PersonModel) {
    this.removalDateTime = person.removalDateTime;
    this.removalDatePersonHashId = person.personMasterHashId;
    this.errorModel = [];
    this.errorMsg = '';
    this.personRemovalDateModal.show();
  }

  public UpdatePersonRemovalDate() {
    this.isLoading = true;
    let personRemoveModel = new PersonRemoveModel();
    personRemoveModel.personMasterHashId = this.removalDatePersonHashId;
    personRemoveModel.removalDateTime = this.removalDateTime;

    this.personService.UpdatePersonRemovalDate(personRemoveModel).subscribe(
      res => {
        this.isLoading = false;
        if (res.data) {
          this.GetPersonList();
          this.personRemovalDateModal.hide();
        }
        else {
          this.errorModel = res.error;
          this.errorMsg = res.error;
        }

      },
      error => {
        this.personRemovalDateModal.hide();
        this.errorMsg = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      });
  }

  public ActivatePerson(personHashId:string) {
    this.isLoading = true;  

    this.personService.ActivatePerson(personHashId).subscribe(
      res => {
        this.isLoading = false;
        if (res.data) {
          this.GetPersonList();
          this.popupMsg = this.translate.instant("LblPersonActiveSuccess", [
            this.module
          ]);
          this.popupTitle = this.translate.instant('LblSuccess');
          this.ShowSuccessPopup();

        }
        else {
          this.errorModel = res.error;
          this.errorMsg = res.error;
        }

      },
      error => {        
        this.errorMsg = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      });
  }
  

  public DeletePerson(formData: any) {
    this.isLoading = true;
    this.personService.DeletePerson(formData).subscribe(
      res => {
        this.deletePersonModal.hide();
        this.DataListModel.currentPage = 1;
        this.GetPersonList();
        if (res && res.error != "") {
          this.validationMessage = res.error;
          this.deletePersonModal.hide();

          this.popupTitle = this.translate.instant("LblWarning");
          this.ShowAlertModal();
        } else {
          this.popupMsg = this.translate.instant("LblRecordRemovedSuccess", [
            this.module
          ]);
          this.popupTitle = this.translate.instant('LblSuccess');
          this.ShowSuccessPopup();
        }
      },
      error => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      }
    );
  }

  public OnSort(sortName: string) {
    this.DataListModel.sortType = sortName;
    this.DataListModel.sortReverse = !this.DataListModel.sortReverse;
    this.GetPersonList();
  }

  onSubmit(forms: any) {
    this.model.personMasterHashId = this.deletePersonHashId;

    this.DeletePerson(JSON.stringify(this.model));
  }

  public OnSearch(event: any) {
    this.DataListModel = this.authService.GetSearchParameters(
      this.DataListModel,
      event.searchTerm,
      event.isReset
    );
    this.GetPersonList();
  }

  public OnPageChanged(event: any): void {
    this.DataListModel.currentPage = event.page;
    this.GetPersonList();
  }

  public OnPagingChange(event: any) {
    this.DataListModel.currentPage = 1;
    this.DataListModel.totalItems = 0;
    this.DataListModel.itemsPerPage = event.itemPerPage;
    this.GetPersonList();
  }

  public OnExport(event: any) {
    this.isLoading = true;
    this.personService.ExportPersonList(this.DataListModel).subscribe(
      (res: any) => {
        if (res && res._body) {
          let fileName = "Person" + new Date().toISOString() + ".csv";
          this.authService.DownloadFile(fileName, res._body);
        }
        this.isLoading = false;
      },
      (error: any) => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      }
    );
  }

  public ShowConfirmModal(personHashId: string): void {

    this.isLoading = false;
    this.deletePersonHashId = personHashId;
    this.errorModel = null;

    this.model.personMasterHashId = personHashId;
    this.model.isDelete = false;

    this.popupMsg = this.translate.instant("LblRecordDeleteConfirmation", [
      this.module
    ]);

    this.deletePersonModal.show(this.message);
  }

  public HideConfirmModal(): void {
    this.deletePersonHashId = "";
    this.deletePersonModal.hide();
  }

  public SuccessAlertModalClick(): void {
    this.alertModal.hide();
    this.deletePersonModal.hide();
  }

  public ShowAlertModal(): void {
    this.isLoading = false;
    this.alertModal.show();
  }

  public HideAlertModal(): void {
    this.alertModal.hide();
  }

  public ShowSuccessPopup(): void {
    this.successPopup.show();
  }

  public HideSuccessPopup(): void {
    this.successPopup.hide();
    this.deletePersonModal.hide();
  }

  public ConfirmSuccessPopup(): void {
    this.successPopup.hide();
  }
  ngOnDestroy() {
    this.authService.SetFilter(this.constructor.name, this.DataListModel);
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/person/components/person-list.component.ts